import { uuid } from '@leland-dev/leland-ui-library';
import { type SendbirdChatWith, UserEventHandler } from '@sendbird/chat';
import { type GroupChannelModule } from '@sendbird/chat/groupChannel';
import { useEffect, useState } from 'react';

import { type Scalars } from '../__generated-gql-types__/globalTypes';

export const useUnreadMessageCount = (
  applicantId: Possible<Scalars['ApplicantUrn']['output']>,
  sendbirdClient: Possible<SendbirdChatWith<GroupChannelModule[]>>,
): number => {
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);

  useEffect(() => {
    if (!applicantId || !sendbirdClient) {
      return;
    }

    const sendbirdUserId = applicantId;

    let isCancelled = false;
    const id = uuid();

    void (async () => {
      await sendbirdClient.connect(sendbirdUserId);

      const initialUnreadMessageCount =
        await sendbirdClient.groupChannel.getTotalUnreadMessageCount();

      // for async useEffect, ignore results if effect has unmounted
      if (isCancelled) return;

      setUnreadMessageCount(initialUnreadMessageCount);
      const userEventHandler = new UserEventHandler({
        onTotalUnreadMessageCountChanged: (count) =>
          setUnreadMessageCount(count.groupChannelCount),
      });

      sendbirdClient.addUserEventHandler(id, userEventHandler);
    })();

    return () => {
      isCancelled = true;
      sendbirdClient.removeUserEventHandler(id);
      void sendbirdClient.disconnect();
    };
  }, [applicantId, sendbirdClient]);

  return unreadMessageCount;
};
